import SegmentProgression from './segmentProgression'
export default SegmentProgression
